export default "__VITE_ASSET__DIYFuVxV__"